import React from "react";
import "./CustomChartTooltip.scss";
import { formatCurrency, formatWithCommas } from "../../assets/helpers";
import { formatStringWithSpace } from "../../assets/helpers/excelDownload";

const CustomChartTooltip = ({
  active,
  payload,
  label,
  labelFormatter,
  valueFormatter,
  variant = "default",
  data = [],
  Intensity = false,
  format,
  tooltipType
}) => {
  console.log(payload,'kljfkdjfkdfjdkfjd');
  if (active && payload && payload.length) {
    const formattedLabel = labelFormatter ? labelFormatter(label) : label;

    // Define these only for the "default" variant
    let loansAmount, totalLoans;
    if (variant === "default") {
      const currentDataPoint =
        Array.isArray(data) && data.length > 0
          ? data.find((item) => item.name === label) || {}
          : {};
      loansAmount =
        currentDataPoint.LoansAmount ||
        (payload.length > 0
          ? payload.reduce((sum, entry) => sum + (entry.value || 0), 0)
          : 0);

      totalLoans = currentDataPoint.total_loan_count || "N/A";
    }
    return (
      <div className={`custom-chart-tooltip ${variant}`}>
        {/* Variant 1: Default (used for Recovery vs Pending) */}
        {variant === "default" && (
          <div className="varient1_tooltip">
            {
              !Intensity && tooltipType !== 'productivity' &&  tooltipType !== 'monthly-ptp' && (
                <div className="tooltip-row">
                  <span className="tooltip-key">Total Loans:</span>
                  <span className="tooltip-value">{formatWithCommas(totalLoans)}</span>

                </div>
              )
            }
            <div className="tooltip-row">
              <span className="tooltip-key">{Intensity ? "Name" : tooltipType === 'productivity' ? 'Action Code' : tooltipType === 'monthly-ptp' ? 'Date' : "Loans Amount:"}</span>
              <span className="tooltip-value" style={{ paddingLeft: '10px' }}>
                {(Intensity || tooltipType === 'productivity' || tooltipType === 'monthly-ptp') ? payload?.[0].payload?.name : formatCurrency(loansAmount, format)}
              </span>


            </div>

            {
              tooltipType === 'productivity' && (
                <div className="tooltip-row">
                  <span className="tooltip-key">Total Loans:</span>
                  <span className="tooltip-value">{formatCurrency(payload?.[0].payload?.total_loans)}</span>

                </div>
              )
            }

            {payload.map((entry, index) => (
              <div key={index} className="tooltip-row">
                <span className="tooltip-key">{formatStringWithSpace(entry?.name)}:</span>
                <span className="tooltip-value">
                  {(Intensity || tooltipType === 'monthly-ptp') ? formatWithCommas(entry.value) : formatCurrency(entry.value, format)}
                </span>

              </div>
            ))}
          </div>
        )}

        {/* Variant 2: Detailed (used for Action Code Coverage) */}
        {variant === "detailed" && (
          <div className="varient2_tooltip">
            <div className="tooltip-header">
              <p className="tooltip-total">
                Total No. of Attempts :{" "}
                {payload
                  .reduce((sum, entry) => sum + (entry.value || 0), 0)
                  .toLocaleString()}
              </p>
            </div>
            <div className="data">
              {payload.map((entry, index) => {
                const name = entry?.name?.length > 8
                 ? entry?.name?.slice(0,8
                  
                )+'...' : entry?.name;
                return (
                   <div key={index} className="tooltip-row">
                  <span
                    className="legend-color-box"
                    style={{
                      width: "8px",
                      height: "8px",
                      flexShrink: 0,
                      borderRadius: "2px",
                      background: entry.color || "#000",
                      marginRight: "3px",
                      display: "inline-block",
                    }}
                  ></span>
                  <span className="tooltip-value">
                    {`${name}: ${valueFormatter
                      ? valueFormatter(entry.value || 0)
                      : entry.value || 0
                      }`}
                  </span>
                </div>
                )
              })}
            </div>
          </div>
        )}

        {/* Variant 3: Compact (used for HML Categorization) */}
        {variant === "compact" && (
          <div className="tooltip-compact">
            <div className="tooltip-static-info">
              <div className="tooltip-row">
                <span className="tooltip-key">Team Leader</span>
                <span className="tooltip-value" style={{fontSize:'12px',marginLeft:'5px'}}>{payload?.[0]?.payload?.name}</span>
              </div>
              <div className="tooltip-row">
                <span className="tooltip-key">Team members</span>
                <span className="tooltip-value" style={{fontSize:'12px'}}>{formatWithCommas(payload?.[0]?.payload?.team_members)}</span>
              </div>
            </div>
            <div className="tooltip-dynamic-info">
              {payload.map((entry, index) => (
                <div key={index} className="tooltip-row">
                  <span className="tooltip-key">
                    <span
                      className="color-box"
                      style={{ backgroundColor: entry.color || "#000" }}
                    />
                    {entry.name}
                  </span>
                  <span className="tooltip-value">
                    {valueFormatter
                      ? valueFormatter(entry.value || 0)
                      : `${entry.value || 0}%`}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default CustomChartTooltip;
